
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

import MeetingList from './Meeting/List'
import UserCenter from './User/UserCenter'

export default {
name: 'index',
components: {
Tabbar,
TabbarItem,
MeetingList,
UserCenter
},

data () {
return {
tabIndex: 0,
}
},
mounted () {
},

methods: {
}
}
